import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { Section } from '../Section';
import { Select } from '../Select';
import { RadioWrapper, Radio, SelectWrapper } from './styles';

const MONTHS_OPTIONS = moment
	.months()
	.map((monthName, index) => ({ key: index + 1, value: monthName }));

export const YearSettingsSection = ({
	financialYearStartMonth,
	animationIndex,
	onChange,
}) => {
	const useFinancialYear = financialYearStartMonth !== null;

	const handleMonthChange = event => {
		const selectedOption = MONTHS_OPTIONS.find(
			({ value }) => value === event.target.value
		);

		onChange({
			financialYearStartMonth: selectedOption.key,
		});
	};

	const selectedMonthOption =
		MONTHS_OPTIONS.find(option => option.key === financialYearStartMonth) ||
		MONTHS_OPTIONS[0];

	return (
		<Section
			title="Spend over time year settings"
			animationIndex={animationIndex}
		>
			<RadioWrapper>
				<Radio
					name="useFinancialYear"
					checked={!useFinancialYear}
					onChange={_0 => {
						onChange({ financialYearStartMonth: null });
					}}
				>
					Calendar year (January - December)
				</Radio>
				<Radio
					name="useFinancialYear"
					checked={!!useFinancialYear}
					onChange={_0 => {
						onChange({ financialYearStartMonth: 1 });
					}}
				>
					Financial year starts in
				</Radio>
			</RadioWrapper>

			<SelectWrapper>
				<Select
					name="financialYearStartMonth"
					options={MONTHS_OPTIONS}
					value={selectedMonthOption.value}
					onChange={handleMonthChange}
				/>
			</SelectWrapper>
		</Section>
	);
};

YearSettingsSection.propTypes = {
	financialYearStartMonth: PropTypes.number,
	animationIndex: PropTypes.number.isRequired,
	onChange: PropTypes.func.isRequired,
};

export default YearSettingsSection;
